import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { AuthActionCreators } from 'app/reducers/AuthRedux'
import { AppActionCreators } from 'app/reducers/AppRedux'
import { colors } from 'theme'
import { getSessionData } from 'app/selectors'
import { image } from 'services'
import { IonIcon, Button } from 'controls'
import { companyConfig } from 'globalConfigApp'

import VersionButton from './VersionButton'
import MenuList from './MenuList'
import menus, { specialMenuItems } from './menuConfiguration'
import { menu, menuGlobalStyles } from './styles'

export const PublishButton = () => (
  <Button
    fullWidth
    color="primary"
    href="/dashboard/properties/create"
    as="/dashboard/properties/create"
  >
    <IonIcon
      icon="ios-home"
      style={{
        fontSize: '1rem',
        padding: '0 .3rem'
      }}
    />{' '}
    Crear Propiedad
  </Button>
)

/**
 * Combines special menu items with regular menus
 * @param {Array} regularMenus - Regular menu items
 * @returns {Array} - Combined menu items with special items at start and end
 */
const getAllMenuItems = (regularMenus) => [
  ...specialMenuItems.start,
  ...regularMenus,
  ...specialMenuItems.end
]

class Menu extends Component {
  static propTypes = {
    menus: PropTypes.array,
    sessionData: PropTypes.shape({
      token: PropTypes.string
    }),
    menuExpanded: PropTypes.bool.isRequired,
    actions: PropTypes.shape({
      toggleMenu: PropTypes.func.isRequired,
      logoutRequest: PropTypes.func.isRequired,
      setMenuExpanded: PropTypes.func.isRequired
    }).isRequired
  }

  static defaultProps = {
    menus: [],
    sessionData: { token: '' }
  }

  constructor(props) {
    super(props)
    this.state = {
      openSubmenus: []
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined') {
      const savedState = localStorage.getItem('menuExpanded')
      if (savedState !== null) {
        this.props.actions.setMenuExpanded(JSON.parse(savedState))
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.menuExpanded !== this.props.menuExpanded && typeof window !== 'undefined') {
      localStorage.setItem('menuExpanded', JSON.stringify(this.props.menuExpanded))
    }
  }

  toggleMenu = () => {
    this.props.actions.toggleMenu()
  }

  toggleSubmenu = (index) => {
    this.setState(prev => ({
      openSubmenus: prev.openSubmenus.includes(index)
        ? prev.openSubmenus.filter(i => i !== index)
        : [...prev.openSubmenus, index]
    }))
  }

  handleItemClick = () => {
    if (window.innerWidth < 768 && this.props.menuExpanded) {
      this.props.actions.toggleMenu()
    }
  }

  render() {
    const { openSubmenus } = this.state
    const { menus, sessionData, menuExpanded } = this.props
    const { token } = sessionData

    const allMenuItems = getAllMenuItems(menus)

    return (
      <nav className={classnames('nav', { expanded: menuExpanded, collapsed: !menuExpanded })}>
        <header>
          <div className="header-toggle" onClick={this.toggleMenu}>
            <IonIcon
              icon="ios-menu"
              style={{
                fontSize: '1.5rem',
                color: colors.white,
                cursor: 'pointer'
              }}
            />
          </div>
          {menuExpanded && (
            <a href="/" target="_blank" className="logo-link">
              <img
                src={image('IAD-White.png')}
                alt={companyConfig.name}
                className="logo"
              />
            </a>
          )}
        </header>

        {menuExpanded && (
          <section className="actions">
            <PublishButton />
            <VersionButton />
          </section>
        )}

        <ul className={classnames('menus', { expanded: menuExpanded })}>
          <MenuList
            items={allMenuItems}
            expanded={menuExpanded}
            openSubmenus={openSubmenus}
            onToggleSubmenu={this.toggleSubmenu}
            token={token}
            onExpand={this.toggleMenu}
            onItemClick={this.handleItemClick}
          />
        </ul>

        <style jsx>{menu}</style>
        <style jsx global>{menuGlobalStyles}</style>
      </nav>
    )
  }
}

const mapStateToProps = state => ({
  menus,
  sessionData: getSessionData(state),
  menuExpanded: state.app.menuExpanded,
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      logoutRequest: AuthActionCreators.logoutRequest,
      toggleMenu: AppActionCreators.toggleMenu,
      setMenuExpanded: AppActionCreators.setMenuExpanded,
    },
    dispatch
  )
})

export default connect(mapStateToProps, mapDispatchToProps)(Menu)
